import 'mdn-polyfills/Number.isNaN';

import FallcoConsole   from '../../fallco_console';
import { FallcoClass } from '../../../classes/FallcoClass';
import Utilities       from '../../utilities';

class FiltriForm {
  constructor (working_form) {
    this.working_form = working_form;
    this.work_in_modal = this.get_working_modal().length > 0;

    // Aggiunge gli eventi necessari ai FORM
    this.add_events();

    this.add_methods();

    // Compila i campi del form in base ai parametri dell'url
    this.fill_forms();

    // if (this.working_form.attr("fw-filters-result") !== undefined) {
    this.filters_result = new FiltriResultAlert(this.working_form);
    // }

    return this.working_form;
  }

  get is_filter_active () {
    return;
  }

  /**
   * Aggiunge ai form gli eventi necessari per il corretto funzionamento.
   *
   * Gestisce il click dei pulsanti SUBMIT e RESET ed ascolta gli event "submit" e "reset" dei form.
   */
  add_events () {

    this.working_form.on('submit', e => this.on_submit_click(e));
    this.working_form.on('reset', e => this.on_reset_click(e));

    // Attributo aggiunto per compatibilit? con functions.js il quale, all'uscita dalla pagina avvisa l'utente che c'erano dati non salvati
    // anche nel form.

    setTimeout(() => {
      this.working_form.find('input, select, textarea')
        .on('focus', function () {
          $(this).data('modificato', window.modificato);
        })
        .on('change', function () {
          window.modificato = $(this).data('modificato');
          $(this).parents('form').data('stato_filtri', 'changed')
        })
        .on('keyup', function () {
          $(this).parents('form').data('stato_filtri', 'changed')
        })
        .off('keypress')
        .unbind('keypress');
    }, 750);
  }

  /**
   *
   */
  add_methods () {
    this.working_form[0].set_result_message = text_array => {
      this.filters_result.set_alert_text(text_array);
    };
    this.working_form[0].url_string         = (return_boolean) => {
      return this.url_string(return_boolean);
    };
    this.working_form[0].filters_params     = () => {
      return this.filters_params();
    };
  }

  /**
   * Effettua il riempimento dei campi del form in base al parametro "filter" presente nell'url.
   * Prende quindi in considerazione solo i campi che sono indicati nell'url che devono essere compilati.
   *
   * Questo metodo viene usato solo al caricamento della pagina, cos? che se ci sono dei filtri attivi
   * e la pagina viene ricaricata, gli stessi filtri vengano riselezionati automaticamente.
   */
  fill_forms () {
    let url_data = this.parse_url();

    // Variabile che conterrà gli id dei parent dei form che sono all'interno di un elemento con classe "collapse".
    // Si controlla quindi il caso in cui si stia usando Bootstrap e l'animazione "collapse".
    let forms_to_open = [];

    // elemento js del bottone dei filtri
    let filters_button;

    // Se non c'è alcun filtro nell'url salta questo metodo.
    if (!url_data) {
      return;
    }

    // stringa che viene stampata nel bottone col numero dei filtri occupati
    let strAppliedFilters = ''

    // contatore dei filtri applicati
    let appliedFilters = 0;
    let collapse_id;

    // controlliamo se la classe btn-toolbar-filtri è presente e abilitiamo i badge per la ricerca
    let toolbarList = document.querySelectorAll('.btn-toolbar-filtri');
    if(toolbarList.length > 0){
      toolbarList.forEach((toolbar)=>{
        this.badgeContainer(toolbar);
      })
    }

    // Per ogni parametro che c'è nei filtri, ne trova il control che ha quel nome e ne assegna il valore.
    // Il ciclo quindi prende in considerazione solo i campi che sono richiesti nell'url. Gli altri non li considera.
    Object.keys(url_data).map(key => {
      let value = url_data[key];
      let control = this.working_form.find('[name=\'' + key + '\']');
      let form_can_collapse = control.closest('form').attr('fw-filters-form') !== 'closed' && control.closest('form').parent().hasClass('collapse');
      let form = $(control.prop('form'));

      // incremento il contatore di filtri applicati
      appliedFilters = ++appliedFilters;

      // Se non viene trovato nessun control con quel nome, lo salta.
      if (control.length === 0) {
        return;
      }

      // Se viene settato un attributo data-value, questo viene usato al posto del dato dell'URL
      if (control.data('value')) {
        value = control.data('value');
      }

      // Prima di impostare i valori dei controls, toglie il flag da tutti i checkbox che sono flaggati di default,
      // così che non li si debba passare forzatamente nell'url con valore false.
      // Controlla il data "checkbox_cleared" del form, così da assicurarsi che questa pulizia venga fatta una volta per form.
      if (!form.data('checkbox_cleared')) {
        control.closest('form').find('input[type=\'checkbox\']:checked')
          .prop('checked', false)
          .attr('checked', false);

        form.data('checkbox_cleared', 'true');
      }

      // In base al tipo di control, lo compila.
      switch (control.prop('nodeName').toLowerCase()) {
      case 'input':
        // Switch in base alla tipologia di input
        switch (control.attr('type')) {
        case 'checkbox':
          value = value === control.val() ? 1 : 0;

          let bool_val = Boolean(value);

          control.prop('checked', bool_val)
            .attr('checked', bool_val);

          break;
        case 'radio':
          control.parent().find('[value=\'' + value + '\']')
            .prop('checked', true);

          break;
        default:
          control.val(value);
        }
        break;
      case 'select':

        if(control[0].hasAttribute('multiple') && control[0].classList.contains('selectpicker')){
          let arr_values = value.split(',');
          $(control).selectpicker('val', arr_values);
        } else{
        control.find('option[value=\'' + value + '\']')
          .attr('selected', 'selected');
        }

        break;
      case 'textarea':

        break;
      }

      // Dopo che viene assegnato il valore del campo, chiama l'evento "change", così che se il form
      // ha delle azioni che devono accadere al "change" di quel campo, ciò avviene.
      // Effettua un controllo per i radio così chiama l'evento associato solo sul control selezionato.
      if (control.length === 1) {
        control.trigger('change');
      } else {
        control.parent().find(':checked').trigger('change');
      }

      // Controlla se il form ha come parent un elemento con classe "collapse" di bootsrap.
      collapse_id = control.closest('form').parent().attr('id');

      if (form_can_collapse) {
        // Se l'id dell'elemento che contiene il form non è ancora nell'array "forms_to_open" lo aggiunge.
        // Questa array verrà poi usata per capire quali form devono essere aperti.
        if (collapse_id && forms_to_open.indexOf(collapse_id) === -1) {
          forms_to_open.push(collapse_id);
        }
      }
      if(toolbarList.length > 0) {
        this.addBadge(control, value);
      }
    });
    // Toglie il data "checkbox_cleared" dai form visto che non serve pi?.

    this.working_form.data('checkbox_cleared', null);
    // Aggiunge il numero dei filtri applicati al testo del bottone

    if (appliedFilters > 1) {
      strAppliedFilters = ` (${appliedFilters} applicati)`
    } else {
      strAppliedFilters = ` (${appliedFilters} applicato)`
    }

    // se trova il bottone 'Fitri ricerca' ne cambia il data-content per visualizzare il numero di filtri applicati
    if (collapse_id) {
      filters_button = document.querySelector('.btn-filtri[data-target="#' + collapse_id + '"]');
    }
    // se non è presente la nuova toolbar grafica con i badge aggiunge il testo
    if (filters_button && !toolbarList) {
      filters_button.dataset.content = strAppliedFilters;
    }

    // In base agli id nell'array "forms_to_open" attiva su ogni elemento il metodo Bootstrap "collapse('show')"
    // per mostrare il form dei filtri.
    // Prima però controlla se il metodo "collapse" esiste davvero.
    if ($.fn.collapse) {
      setTimeout(function () {
        // se presente il div contenitore dei badge con la nuova grafica impostiamo il collapse chiuso
        if(toolbarList.length > 0){
          $('#' + forms_to_open.join(' #')).collapse('hide');
        } else {
          $('#' + forms_to_open.join(' #')).collapse('show');
        }

        var bs_toggle = $('input[type=\'checkbox\'][name=\'filter_switch\']');
        if (bs_toggle.length > 0) {
          bs_toggle = bs_toggle.data('bs.toggle');

          if (bs_toggle) {
            bs_toggle.on();

          }
        }
      });
    }
  }

  /**
   * Estensione della funzione "serialize" di jQuery che permette di recuperare i dati di un form,
   * e formattarli come url da codificare per effettua un filtro sulla pagina.
   *
   * Ritorna una stringa formattata cos?:
   *       chiave|valore^chiave|valore^chiave|valore
   * Il simbolo | indica la separazione tra la chiave ed il valore,
   * mentre il simbolo ^ indica la separazione tra diversi elementi.
   *
   * @return {string}
   */
  serialize_filter () {
    let form_data = this.working_form.serializeArray();
    let filters   = [];

    const checkboxes = this.working_form.find('[type=\'checkbox\']');

    checkboxes.each((i, checkbox) => {
      let valueOff = checkbox.getAttribute('data-value-off');

      if (!valueOff || checkbox.checked) {
        return;
      }

      form_data.push({
        name:  checkbox.name,
        value: checkbox.getAttribute('data-value-off') || 'off'
      });
    });

    form_data.map(function (obj) {
      // obj.value = obj.value.trim();
      if (obj.value !== '') {

        if(filters.length > 0) {
          let duplicated_key = false;
          let arr_filters = filters.toString().split(',')
          arr_filters.forEach((itm)=>{
            let item = itm.split('|')
            if(item.includes(obj.name)){
              duplicated_key = true;
            } else {
              return
            }
          })
          if(!duplicated_key){
            filters.push(obj.name + '|' + obj.value);
          } else {
            Object.keys(filters).forEach((el, index) => {
              if (filters[el].includes(obj.name)) {
                let values = filters[el].split('|');
                values[1] = values[1] + ',' + obj.value
                filters[el] = values[0] + '|' + values[1]
              }
            })
            // filters[obj.name] += ','+obj.value
          }

        } else {
          filters.push(obj.name + '|' + obj.value);
        }
      }
    });

    return filters.join('^') + '^';
  };

  /**
   * Dai parametri passati nell'url, cerca "filter" e ne decodifica il valore,
   * ritornando poi un Object di tipo {nome_campo:valore_campo, nome_campo:valore_campo}
   *
   * @return Object
   */
  parse_url () {
    let helper_url = $.helper.url;

    if (this.work_in_modal) {
      helper_url = this.get_working_modal(true).url;
    }

    let url_string = helper_url.get_parameter_by_name('filter');
    let url_obj    = {};

    if (!url_string) {
      return null;
    }

    url_string = decodeURI(url_string);

    url_string.split('^').map(function (str) {
      let str_array;

      if (str === '') {
        return;
      }

      str_array             = str.split('|');

      url_obj[str_array[0]] = str_array[1];
    });

    return url_obj;
  }

  /**
   * Ritorna il modale dentro al quale si trova il form su cui si sta lavorando.
   * Se non esiste, ritorna null.
   *
   * @param {Boolean} [data] Indica se ritornare l'object "modal_popup_obj" anzich? l'elemento html.
   * @return {jQuery | Object}
   */
  get_working_modal (data) {
    let modal = this.working_form.closest('.modal');

    if (modal.length === 0) {
      return [];
    }

    if (data) {
      return modal.data('modal_popup_obj');
    }

    return modal;
  }

  /**
   * Evento al click sul pulsante di SUBMIT del form.
   *
   * - blocca l'azione di default del form per il submit,
   * - crea il parametro "filter" da passare nell'url
   * - recupera i dati dei campi del form e li codifica nel parametro "filter" dell'url.
   * - effettua il reload della pagina aggiungendo al url il parametro "filter" appena creato.
   *
   * @param {MouseEvent} e
   */
  on_submit_click (e) {
    e.preventDefault();
    if (document.activeElement) {
      let controlType  = Utilities.get_control_type(document.activeElement);
      let controlsList = ['text', 'select', 'textarea', 'checkbox', 'radio'];

      if (controlsList.includes(controlType)) {
        document.activeElement.blur();
      }
    }

    // Recupera dal form una stringa da passare nell'url formattata cos?: chiave|valore^chiave|valore
    let formatted_filters_string = this.serialize_filter();
    let action = this.working_form.attr('fw-filters-form') !== 'closed' ? this.working_form.attr('fw-filters-form') : '';
    let url;

    if (action) {
      url = action;
    } else if (this.work_in_modal) {
      url = this.get_working_modal(true).url.toString();
    } else {
      url = window.location.href;
    }

    if (formatted_filters_string.length > 0) {
      // Esegue il redirect della pagina impostando i filtri nel parametro "search" dell'url.
      url = url
        .url_change_parameter_by_name(
          { 'filter': formatted_filters_string }
        )
        .url_remove_parameter_by_name('page');
    } else {
      url = undefined;
    }

    FallcoConsole.log('FILTRI: nuovo url -', url);

    if (typeof js_submit !== 'undefined') {
      window.js_submit = true;
    }

    $.helper.loading_frame.show();

    this.reload_url(url);
  }

  /**
   * Evento al click del pulsante RESET del form.
   *
   * - permette che il form venga resettato direttamente dall'evento del browser
   * - toglie dall'url il parametro "filter" e quindi effettua il refresh della pagina.
   *
   * @param {MouseEvent} e
   */
  on_reset_click (e) {
    if (window.hasOwnProperty('modificato')) {
      window.modificato = false;
    }
    this.reload_url();
  }

  /**
   * Esegui il reload della pagina tenendo conto dell'url passato e del fatto che si stia lavorando in un modale oppure no.
   * Se non viene passato alcun url, rimuove dall'url attualmente in uso tutti filtri presenti.
   *
   * @param {String} [url]
   */
  reload_url (url) {
    let modal_obj = this.get_working_modal(true);

    if (!url) {
      if (this.work_in_modal) {
        url = modal_obj.url.toString().url_remove_parameter_by_name(['filter', 'page']);
      } else {
        url = window.location.toString().url_remove_parameter_by_name(['filter', 'page']);
      }
    }

    if (fallco.settings.test) {
      window.location.assign(url);
    } else if (this.work_in_modal) {
      $(document).one('loaded.modal.helper', function () {
        $.helper.loading_frame.hide();
      });

      modal_obj.url_params = {};
      modal_obj.load_content_from_url(url);
    } else {
      window.location.href = url;
    }
  }

  /**
   * Ritorna l'url completo in base ai dati presenti nel form dei filtri.
   *
   * @return {String}
   */
  url_string (return_boolean) {
    let formatted_filters_string = this.serialize_filter();
    let url                      = $.helper.url;

    if (this.work_in_modal) {
      url = this.get_working_modal(true).url;
    }

    if (return_boolean) {
      return url.get_parameter_by_name('filter') !== undefined;
    }

    return url.change_parameter_by_name({ 'filter': formatted_filters_string });
  }

  /**
   * Ritorna una stringa contenente i parametri che verranno poi passati nell'url per eseguire il filtro.
   * Ritorna una stringa formattata cos?:
   *       chiave|valore^chiave|valore^chiave|valore
   *
   * @return {string}
   */
  filters_params () {
    return this.serialize_filter();
  }

  /**
   * Crea un div contenitore per racchiudere  all'interno i filtri attivi
   */
  badgeContainer(toolbar){
    let btnCollapseFiltri = toolbar.querySelector('button.btn-filtri');
    let idFiltriContainer = btnCollapseFiltri.getAttribute('data-target') || btnCollapseFiltri.getAttribute('data-bs-target');
    let newBadgeContainer = document.createElement("div");
    newBadgeContainer.className = "fw-badge-filtri-container";
    newBadgeContainer.setAttribute('riferimento', 'relativo-ai-filtri'+ idFiltriContainer);
    newBadgeContainer.innerHTML = '<label class="form-control-static">Filtri applicati : </label><div ref="'+idFiltriContainer+'"></div>';
    toolbar.append(newBadgeContainer);
  }
  /**
   * Crea un singolo badge per filtro attivo, controllando se è presente la label e il name del filtro
   */
  addBadge(control, value){
    let filtro = control[0];
    let groupfiltro = filtro.closest('.form-group') || filtro.closest('.form-floating') ;
    let label = groupfiltro.querySelector('label');
    let formContainer = filtro.closest('form');
    let collapseContainer = formContainer.getAttribute('.collapse') || formContainer.closest('.collapse');
    let idContainer = collapseContainer.getAttribute('id');
    let containerBadges = document.querySelector("[ref='#"+idContainer+"']");

    if(filtro.type === 'select-one') {
      let valueFromSelect = filtro.querySelector('option[value="'+value+'"]').innerText;
      value = valueFromSelect;
    }
    // gestiamo la label
    if(!label){
      if(!filtro.name){
        fallco.console.warn('Attenzione uno dei filtri non ha l\'attributo "name" e la relativa label. Il badge verrà creato senza etichetta.');
        label = '';
      } else {
        label = filtro.name.toCapitalLetters();
        fallco.console.warn('Non è presente label relativa al filtro: ' + filtro.name + '. L\'etichetta del badge verrà creato con il name del filtro.');
      }
    }
    let newBadge = document.createElement("span");
    newBadge.className = "badge rounded-pill mx-2";
    newBadge.innerHTML = '<p class="form-control-static mb-0">'+label.innerText + ': ' + value + '<i class="fas fa-times" filtro="'+filtro.name+'" labelfiltro="'+label.innerText+'"></i></p>';
    containerBadges.appendChild(newBadge);

    this.addBadgeEvents(newBadge);
  }
  /**
   * Aggiunge l'evento elimina filtro direttamente al badge
   */
  addBadgeEvents(badge) {
    let badgeIcon = badge.querySelector('i.fas');
    let labelText = badgeIcon.getAttribute('labelfiltro');
    let filterName = badgeIcon.getAttribute('filtro');

    badgeIcon.addEventListener('click', (e) => {
      alertify.confirm('Il filtro "' + labelText + '" verr&agrave; rimosso, vuoi procedere?', () => {
        let filtro = document.querySelector("[name=" + filterName + "]");
        filtro.value = '';
        if(this.filters_params() != '^') {
          this.reload_url(this.url_string());
        } else {
          this.reload_url();
        }
      }, function () {
        return;
      })
    })
  }
}

class FiltriResultAlert {
  constructor (working_form) {
    this.form           = working_form;
    this.result_counter = Number(working_form.attr('fw-filters-result'));

    this.init_alert();

    return this;
  }

  init_alert () {
    let result_alert = this.form.find('[fw-result-alert]');

    if (result_alert.length === 0) {
      result_alert = $('<div class="collapse" aria-expanded="true" style="">\n' +
        '      <div class="alert alert-info mb-0 mt-3">\n' +
        '        <span class="main-message">Risultati della ricerca: <span data-content="message"></span></span>\n' +
        '        <span style="display: block;" class="extra-message hidden d-none" data-content="extra-message"></span>\n' +
        '      </div>\n' +
        '    </div>');

      this.form.append(result_alert);
    }

    this.result_alert = result_alert;

    this.set_alert_text();
  }

  /**
   * Imposta il testo da mostrare nell'alert sotto i filtri.
   * Di default mostra il numero di risultati trovati a patto che l'attributo "fw-filters-result" del form sia definito.
   *
   * Se si passa il parametro "test_array" il testo di questo parametro verr� mostrato sotto il conteggio dei risultati trovati.
   *
   * @param {Array<String> | String} [text_or_array]
   */
  set_alert_text (text_or_array) {
    let message                 = '';
    let extra_message           = '';
    let show_alert              = false;
    let main_message_container  = this.result_alert.find('.main-message');
    let main_message            = main_message_container.find('[data-content=\'message\']');
    let extra_message_container = this.result_alert.find('[data-content=\'extra-message\']');
    let is_filter_active        = this.form[0].url_string(true);

    switch (this.result_counter) {
    case 0:
      message = 'Trovati <strong>' + this.result_counter + ' risultati</strong>';
      break;
    case 1:
      message = 'Trovato <strong>' + this.result_counter + ' risultato</strong>';
      break;
    default:
      message = 'Trovati <strong>' + this.result_counter + ' risultati</strong>';
    }

    /**
     * Se il counter dei risultati viene passato, allora mostra il messaggio relativo ai risultati trovati
     */
    if (!Number.isNaN(this.result_counter) && this.result_counter >= 0 && is_filter_active) {
      main_message.html(message);
      show_alert = true;
    }
    main_message_container.toggleClass('hidden d-none', (Number.isNaN(this.result_counter) || !is_filter_active));

    /**
     * Se viene passato una stringa o un array di stringhe le mostra nell'alert.
     */
    if (text_or_array) {
      extra_message = text_or_array;

      if (text_or_array instanceof Array) {
        extra_message = text_or_array.join('<br>');
      }

      extra_message_container.html(extra_message);

      show_alert = true;
    }
    extra_message_container.toggleClass('hidden d-none', text_or_array === '');

    // Aspetta che tutte le altre operazioni siano concluse, in modo che l'animazione del collapse possa essere fluida.
    setTimeout(() => {
      this._controlloSelectFloatingLabel();
      this.result_alert.collapse(show_alert ? 'show' : 'hide');
    });
  }

  // gestisce le floating label delle select
  _controlloSelectFloatingLabel(){
    let formFiltri = document.querySelector('form[fw-filters-form]');
    let listaSelect = formFiltri.querySelectorAll('.form-floating select');
    if(listaSelect.length === 0){
      return;
    }
    // gestione select filtri floating label
    listaSelect.forEach((select) => {
      // impostiamo l'opacità delle label a zero, così la prima volta appariranno in dissolvenza,
      // verrà nascosto l'effetto di troncatura del testo
      let labelSelect = select.closest('.form-floating').querySelector('label');
      labelSelect.style.opacity = 0;
      let value = select.value;
      select.addEventListener('change', (e) => {
        let value = e.target.value;
        select.setAttribute('value', value);
      });
      select.addEventListener('click', (e) => {
        let value = e.target.value;
        select.setAttribute('value', value);
      });

      if(select.value !== ''){
        select.setAttribute('value', select.value);
      } else {
        select.setAttribute('value', '');
      }
    });
  }
}

/**
 * Per associare la gestione dei filtri si deve assegnare l'attributo "fw-filters-form" al form che contiene i filtri.
 * Su una singola pagina possono coesistere pi? di un form che esegua filtri, l'importante ? che ogni form abbia
 * l'attributo "fw-filters-form".
 *
 * Come valore dell'attributo "fw-filters-form" si pu? indicare la pagina nella quale verr? eseguito il filtro.
 *
 * @example
 * ES: <form id="id_desiderato" action="_action_desiderata" fw-filter-form> ... </form>
 *
 * ES: <form id="id_desiderato" action="_action_desiderata" fw-filter-form="/elenco_beni"> ... </form>
 */
class Filtri extends FallcoClass {
  /**
   * @return {{reload_filter: (function(*=): void), get_filter_form: (function(*=, *=): (jQuery|HTMLElement))}}
   */
  constructor () {
    super();

    this._settings = {
      'form-attribute': 'fw-filters-form'
    };

    if (!$.helper) {
      console.error('Libreria \'$.helper\' mancante. Prima di usare i Filtri occorre includere questa libreria.');
    }

    window.addEventListener('DOMContentLoaded', () => this._on_load());

    return super.expose_to_public('filtri', this);
  }

  /**
   * Evento al caricamento della pagina.
   * Inizializza i controlli necessari per i filtri.
   */
  _on_load () {

    // Rimane in ascolto per l'evento loaded chiamata dal caricamento di un modale chiamato tramite "$.helper.modal_popups"
    $(document).on('loaded.modal.helper', (event, modal_popup) => {
      this.reload_filter(modal_popup.$modal);

      // Imposta il parametro "form_changed" su false, cos? che venga resettato il parametro nel caso in cui
      // si ricarichi solo il contenuto del modale.
      modal_popup.form_changed = false;
    });

    this.reload_filter();
  }

  /**
   * Ritorna i form dei filtri presenti sulla pagina.
   *
   * @param {HTMLElement | jQuery | Number} target - Campo che può assumere il posto del parametro "return_index" qualora non si voglia specificare un target ma si voglia eseguire la ricerca su tutta la pagina.
   * @param {Number} [return_index] - Indice del form da ritornare. Se non specificato, ritorna un array con tutti gli elementi trovati, altrimenti ritorna solo il form all'indice passato.
   * @return {jQuery | HTMLElement}
   */
  get_filter_forms (target, return_index) {
    var result;

    // Se il parametro target � di tipo "number", viene usato come se fosse "return_index" ed il target viene settato a null.
    if (typeof target === 'number' && typeof return_index === 'undefined') {
      return_index = target;
      target       = null;
    }

    target = target || document;

    // Si assicura che il target sia di tipo jQuery
    if (!(target instanceof jQuery)) {
      target = $(target);
    }

    result = $('form[' + this._settings['form-attribute'] + ']', target);

    // Se il parametro return_index è settato, ritorna il form all'indice desiderato, altrimenti ritorna tutti gli elementi.
    if (typeof return_index !== 'undefined') {
      return result[return_index];
    } else {
      return result;
    }
  }

  /**
   * Inizializza i controlli da fare sui componenti HTML.
   * Se non viene passato un target, cerca i form su tutta la pagina.
   *
   * @param {HTMLElement | jQuery} [target]
   */
  reload_filter (target) {
    let forms = [];

    if (!$.helper) {
      throw 'Per poter usare i filtri ? necessario includere la libreria \'jquery.helper.js\'!';
    }

    forms = this.get_filter_forms(target);

    if (forms.length === 1) {
      new FiltriForm(forms);
    } else if (forms.length > 1) {
      forms.map((i, form) => {
        form = $(form);
        new FiltriForm(form);
      });
    }
  }

}

export default new Filtri();
